
const CREAM_TEXT_D =
  "m337.951-500.688-.001-72.851q.806.694 2.132 2.21l28.943 34.748 28.526-34.748q1.66-1.765 2.386-2.387.725-.623 1.555-.622 1.142 0 1.608.828.467.83.468 2.594v67.945q0 1.349-.519 1.817-.52.466-1.763.466h-5.811q-1.244 0-1.762-.466-.52-.468-.519-1.817v-48.339l-20.747 25.518q-1.348 1.764-2.074 2.334t-1.556.571-1.557-.571q-.725-.57-2.073-2.334L344.44-551.31v48.339q-.002 1.349-.519 1.817-.52.466-1.765.466zM450.881-501.154q-.519-.468-.52-1.817v-68.048q.001-1.349.52-1.816.52-.466 1.764-.466h5.809q1.244 0 1.763.466.52.467.52 1.816v68.048q0 1.349-.52 1.817-.519.466-1.763.466h-5.809q-1.244 0-1.764-.466M487.175-501.363q-1.866-1.71-1.866-4.304 0-2.698 1.815-4.41 1.814-1.71 4.616-1.71t4.616 1.71q1.816 1.712 1.815 4.41 0 2.594-1.815 4.304-1.814 1.712-4.616 1.712-2.697 0-4.565-1.712m0-16.389q-.517-.467-.517-1.713v-1.555q0-4.046.724-6.794.728-2.75 2.853-5.395 2.127-2.644 6.381-5.861 3.94-3.111 6.223-5.394t3.371-4.512q1.09-2.23 1.089-4.824c0-2.211-.57-4.15-1.712-5.809q-1.71-2.49-4.616-3.734-2.903-1.245-6.534-1.245-4.358.001-8.246 1.609-3.893 1.605-7.418 4.511-.934.934-1.659.933-.416 0-.882-.31-.467-.312-.986-1.036l-2.49-3.528a4.7 4.7 0 0 1-.621-.986 2.2 2.2 0 0 1-.209-.881q0-.52.365-1.038.362-.517 1.089-1.142 9.75-7.986 21.369-7.988 6.43.001 11.772 2.387 5.344 2.386 8.454 6.898 3.113 4.514 3.112 10.737 0 6.017-3.318 10.84-3.32 4.825-10.165 10.01-3.113 2.387-4.722 4.357-1.608 1.97-2.229 3.89-.622 1.918-.623 4.409v1.451q.001 1.246-.52 1.713-.517.466-1.761.466h-5.809q-1.245 0-1.765-.466";

const TEXT_MASK = `url("data:image/svg+xml,${encodeURIComponent(
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='331.199 -591.151 276.756 108.001'><path fill='white' fill-rule='nonzero' d='${CREAM_TEXT_D}'/></svg>`
)}")`;

interface RevealDoorRightProps {
  style?: React.CSSProperties;
}

const SvgRevealDoorRight = ({ style }: RevealDoorRightProps) => (
  <div
    style={{
      position: 'relative',
      width: 369,
      height: 144,
      ...style,
    }}
  >
    {/* Solid charcoal background */}
    <div style={{ position: 'absolute', top: 0, left: 0, width: 369, height: 144, backgroundColor: '#262626' }} />

    {/* Cream shimmer masked to text paths */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        WebkitMaskImage: TEXT_MASK,
        maskImage: TEXT_MASK,
        WebkitMaskSize: '100% 100%',
        maskSize: '100% 100%',
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
      }}
    >
      <div style={{ width: 369, height: 144, backgroundColor: '#f7e5c5' }} />
    </div>

    {/* Brown shadow strip (SVG overlay) */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={369.008}
      height={144.001}
      fill="none"
      viewBox="331.199 -591.151 276.756 108.001"
      style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
    >
      <path fill="#514b44" stroke="none" d="M337.95-483.151v-108h-6.75v108z" />
    </svg>
  </div>
);

export default SvgRevealDoorRight;
